<section class="flex-1 bg-white">
    <div class="max-w-[1400px] mx-auto px-6 py-16 flex flex-col items-start gap-16">

        <!-- Left Column: Registration Form -->
        <div class="w-full">
            <div class="flex items-center gap-4 self-stretch bg-app-background-20 px-4 py-4">
                <div class="text-sm tracking-wider font-light gap-2 flex">
                    <span>Schon registriert aber keine Bestätigungsmail erhalten? <button (click)="openResendLinkModal()" class="text-app-secondary-10 underline font-medium">Hier klicken</button></span>
                </div>
            </div>
            <div class="flex items-center gap-4 self-stretch bg-app-background-20 px-4 py-4 mt-6">
                <div class="text-sm tracking-wider font-light gap-2 flex">
                    Sie haben schon ein Konto? <a routerLink="/anmeldung" class="text-app-secondary-10 font-semibold underline">Hier anmelden</a>
                </div>
            </div>
            <div class="font-fraunce text-5xl font-normal text-app-primary-20 mb-6 mt-12">
                @if (registerSuccess) {
                    Bitte aktivieren Sie Ihr Konto
                } @else {
                    Registrieren
                }
            </div>

            @if (registerSuccess) {
                <div class="bg-app-background-20 rounded-2xl p-8 space-y-6">
                    <p class="text-lg text-app-primary-20 leading-relaxed">
                        Vielen Dank für Ihre Registrierung. Bitte beachten Sie, dass diese erst abgeschlossen ist, sobald Sie den Link anklicken, den wir Ihnen per E-Mail gerade zugesendet haben.
                        <br><br>Wir freuen uns, Sie als Kunden von Patria Cura begrüßen zu dürfen.
                    </p>

                    <div class="pt-6 border-t border-gray-200">
                        <p class="text-sm text-gray-600">
                            Sollten Sie keine E-Mail erhalten haben, schauen Sie bitte auch in Ihrem Spam-Ordner.
                            <br>
                            Bei Problemen mit der Registrierung wenden Sie sich bitte über unser <a [routerLink]="'/kontakt'" class="text-app-secondary-10 underline">Kontaktformular</a> an unseren Support.
                        </p>
                    </div>
                </div>
            } @else {

                <div class="registration-stepper">
                    <mat-vertical-stepper [linear]="true" #stepper [animationDuration]="'500'">
                        <!-- Step 1: Personal Info -->
                        <mat-step [stepControl]="generalFormGroup" errorMessage="Bitte Pflichtfelder richtig ausfüllen.">
                            <form [formGroup]="generalFormGroup" class="space-y-6 py-4">
                                <ng-template matStepLabel>Wer sind Sie?</ng-template>
                                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div class="flex flex-col gap-2">
                                        <label>Anrede</label>
                                        <mat-select formControlName="genderId" class="custom-select">
                                            <mat-option [value]="''">Bitte wählen</mat-option>
                                            @for (gender of genders; track gender.id) {
                                                <mat-option [value]="gender.id">{{ gender.name | gender }}</mat-option>
                                            }
                                        </mat-select>
                                    </div>
                                    <div class="flex flex-col gap-2">
                                        <label>Vorname *</label>
                                        <input matInput placeholder="Vorname" formControlName="firstName" >
                                    </div>
                                    <div class="flex flex-col gap-2">
                                        <label>Geburtsdatum *</label>
                                        <div class="relative">
                                            <input matInput [matDatepicker]="picker" formControlName="dateOfBirth"  placeholder="DD.MM.YYYY">
                                            <mat-datepicker-toggle [for]="picker" matIconSuffix class="absolute right-0 top-2"></mat-datepicker-toggle>
                                            <mat-datepicker #picker [touchUi]="isMobile"></mat-datepicker>
                                        </div>
                                    </div>
                                    <div class="flex flex-col gap-2">
                                        <label>Nachname *</label>
                                        <input matInput placeholder="Nachname" formControlName="lastName" >
                                    </div>
                                </div>
                                <div class="flex pt-4 justify-end">
                                    <button class="btn primary-button" matStepperNext (click)="checkFormValidity(generalFormGroup)">Weiter</button>
                                </div>
                            </form>
                        </mat-step>

                        <!-- Step 2: Contact -->
                        <mat-step [stepControl]="contactFormGroup" errorMessage="Bitte Pflichtfelder richtig ausfüllen.">
                            <form [formGroup]="contactFormGroup" class="space-y-6 py-4">
                                <ng-template matStepLabel>Wie können wir Sie erreichen?</ng-template>
                                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div class="flex flex-col gap-2">
                                        <label>E-Mail *</label>
                                        <input type="email" matInput placeholder="E-Mail" formControlName="email" >
                                    </div>
                                    <div class="flex flex-col gap-2">
                                        <label>Telefonnummer *</label>
                                        <input matInput placeholder="Telefonnummer" formControlName="phoneNumber" >
                                    </div>
                                </div>
                                <div class="flex gap-4 pt-4 justify-end">
                                    <button class="btn quaternary-button" matStepperPrevious>Zurück</button>
                                    <button class="btn primary-button" matStepperNext (click)="checkFormValidity(contactFormGroup)">Weiter</button>
                                </div>
                            </form>
                        </mat-step>

                        <!-- Step 3: Address -->
                        <mat-step [stepControl]="addressFormGroup" errorMessage="Bitte Pflichtfelder richtig ausfüllen.">
                            <form [formGroup]="addressFormGroup" class="space-y-6 py-4">
                                <ng-template matStepLabel>Wie lautet Ihre Anschrift?</ng-template>
                                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div class="flex flex-col gap-2">
                                        <label>Ort *</label>
                                        <input matInput placeholder="Ort" formControlName="city" >
                                    </div>
                                    <div class="flex flex-col gap-2">
                                        <label>Straße *</label>
                                        <input matInput placeholder="Straße" formControlName="street" >
                                    </div>
                                    <div class="flex flex-col gap-2">
                                        <label>Hausnummer *</label>
                                        <input matInput placeholder="Hausnummer" formControlName="houseNumber" >
                                    </div>
                                    <div class="flex flex-col gap-2">
                                        <label>Postleitzahl *</label>
                                        <input matInput placeholder="Postleitzahl" formControlName="zipCode" >
                                    </div>
                                </div>
                                <div class="flex gap-4 pt-4 justify-end">
                                    <button class="btn quaternary-button" matStepperPrevious>Zurück</button>
                                    <button class="btn primary-button" matStepperNext (click)="checkFormValidity(addressFormGroup)">Weiter</button>
                                </div>
                            </form>
                        </mat-step>

                        <!-- Step 4: ID -->
                        <mat-step>
                            <ng-template matStepLabel>Bitte weisen Sie sich aus.</ng-template>
                            <div class="py-4 space-y-8">
                                <div class="p-4 bg-app-background-20 rounded-lg text-xs text-app-secondary-10 border-l-4 border-app-secondary-10">
                                    Die Ausweisdokumente werden mit Ihrem behandelnden Arzt geteilt, sodass eine Identifizierung möglich ist.
                                </div>
                                <div class="p-4 bg-app-background-20 rounded-lg text-xs text-app-secondary-10 border-l-4 border-app-secondary-10">
                                    Wir legen höchsten Wert auf den Schutz Ihrer Privatsphäre. Alle Daten werden verschlüsselt übertragen und ausschließlich für Ihre medizinische Versorgung verwendet.
                                </div>

                                <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
                                    <div class="flex flex-col gap-4">
                                        <label class="text-app-primary-20 font-medium">Vorderseite des Personalausweises *</label>
                                        @if (idDocuments.front.fileData == '') {
                                            <app-file-upload [useBase64Upload]="true" [base64WithInfos]="true" (fileSelected)="onFileSelectedFront($event)" [allowedMimeTypes]="['image/jpeg', 'image/png']"></app-file-upload>
                                        } @else {
                                            <div class="relative group aspect-video overflow-hidden rounded-lg shadow-md border border-gray-200">
                                                <button class="absolute top-2 right-2 bg-red-500 hover:bg-red-600 text-white w-10 h-10 flex items-center justify-center rounded-full shadow-lg z-10 transition-all transform hover:scale-110" (click)="removeFile('front')">
                                                    <i class="fa-solid fa-trash-can text-sm"></i>
                                                </button>
                                                <img [src]="'data:image/jpeg;base64,' + idDocuments.front.fileData" alt="Vorderseite" class="w-full h-full object-cover">
                                            </div>
                                        }
                                    </div>
                                    <div class="flex flex-col gap-4">
                                        <label class="text-app-primary-20 font-medium">Rückseite des Personalausweises *</label>
                                        @if (idDocuments.back.fileData == '') {
                                            <app-file-upload [useBase64Upload]="true" [base64WithInfos]="true" (fileSelected)="onFileSelectedBack($event)" [allowedMimeTypes]="['image/jpeg', 'image/png']"></app-file-upload>
                                        } @else {
                                            <div class="relative group aspect-video overflow-hidden rounded-lg shadow-md border border-gray-200">
                                                <button class="absolute top-2 right-2 bg-red-500 hover:bg-red-600 text-white w-10 h-10 flex items-center justify-center rounded-full shadow-lg z-10 transition-all transform hover:scale-110" (click)="removeFile('back')">
                                                    <i class="fa-solid fa-trash-can text-sm"></i>
                                                </button>
                                                <img [src]="'data:image/jpeg;base64,' + idDocuments.back.fileData" alt="Rückseite" class="w-full h-full object-cover">
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div class="flex gap-4 pt-4 justify-end">
                                    <button class="btn quaternary-button" matStepperPrevious>Zurück</button>
                                    <button class="btn primary-button" (click)="validateStep()">Weiter</button>
                                </div>
                            </div>
                        </mat-step>

                        <!-- Step 5: Password -->
                        <mat-step [stepControl]="finishFormGroup" errorMessage="Bitte Pflichtfelder richtig ausfüllen.">
                            <form [formGroup]="finishFormGroup" class="space-y-6 py-4">
                                <ng-template matStepLabel>Sicherheit muss sein!</ng-template>
                                <div class="grid grid-cols-1 gap-6">
                                    <div class="flex flex-col gap-2 relative">
                                        <label>Passwort *</label>
                                        <div class="relative">
                                            <input [type]="hidePassword ? 'password' : 'text'" matInput placeholder="Passwort" formControlName="password" class="custom-input w-full">
                                            <button (click)="hidePassword = !hidePassword" class="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-app-primary-10 cursor-pointer">
                                                <i class="fa-solid" [ngClass]="{'fa-eye': !hidePassword, 'fa-eye-slash': hidePassword}"></i>
                                            </button>
                                        </div>
                                        @if (finishFormGroup.get('password')!.dirty && finishFormGroup.get('password')!.errors) {
                                            <div class="flex flex-col gap-1 pt-1">
                                                @if (finishFormGroup.get('password')!.errors!['minLength']) { <div class="text-red-500 text-xs">Mindestens 12 Zeichen</div> }
                                                @if (finishFormGroup.get('password')!.errors!['minLowerCase']) { <div class="text-red-500 text-xs">Mindestens 1 Kleinbuchstabe</div> }
                                                @if (finishFormGroup.get('password')!.errors!['minUpperCase']) { <div class="text-red-500 text-xs">Mindestens 1 Großbuchstabe</div> }
                                                @if (finishFormGroup.get('password')!.errors!['minDigits']) { <div class="text-red-500 text-xs">Mindestens 1 Ziffer</div> }
                                                @if (finishFormGroup.get('password')!.errors!['minSpecialCharacters']) { <div class="text-red-500 text-xs">Mindestens 1 Sonderzeichen</div> }
                                            </div>
                                        }
                                    </div>
                                    <div class="flex flex-col gap-2">
                                        <label>Passwort wiederholen *</label>
                                        <div class="relative">
                                            <input [type]="hidePasswordConfirm ? 'password' : 'text'" matInput placeholder="Passwort wiederholen" formControlName="passwordConfirm" class="custom-input w-full">
                                            <button (click)="hidePasswordConfirm = !hidePasswordConfirm" class="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-app-primary-10 cursor-pointer">
                                                <i class="fa-solid" [ngClass]="{'fa-eye': !hidePasswordConfirm, 'fa-eye-slash': hidePasswordConfirm}"></i>
                                            </button>
                                        </div>
                                        @if (finishFormGroup.get('passwordConfirm')!.valid && finishFormGroup.get('password')?.value !== finishFormGroup.get('passwordConfirm')?.value) {
                                            <span class="text-red-500 text-xs">* Passwörter stimmen nicht überein</span>
                                        }
                                    </div>
                                </div>
                                <div class="flex gap-4 pt-4 justify-end">
                                    <button class="btn quaternary-button" matStepperPrevious>Zurück</button>
                                    <button class="btn primary-button" (click)="onSubmit()">Registrieren</button>
                                </div>
                            </form>
                        </mat-step>
                    </mat-vertical-stepper>
                </div>
            }
        </div>
    </div>
</section>
